import L from 'leaflet'
import 'leaflet.browser.print/dist/leaflet.browser.print'

L.BrowserPrint.include({
  _endAutoPolygon: function(e) {
    L.DomEvent.stop(e)
    this._removeAutoPolygon()

    if (this.options.custom && this.options.custom.rectangle) {
      var autoBounds = this.options.custom.rectangle.getBounds()

      this._map.removeLayer(this.options.custom.rectangle)

      var orientation
      if (this.options.custom.mode.options.orientation === 'Portrait' || this.options.custom.mode.options.orientation === 'Landscape') {
        orientation = this.options.custom.mode.options.orientation
      } else {
        orientation = this._getPageSizeFromBounds(autoBounds)
      }
      this._print(this._getMode(orientation, this.options.custom.mode), autoBounds)

      delete this.options.custom
    } else {
      //Вместо _clearPrint используем более общий метод _printEnd
      this._printEnd()
    }
  }
})



// WEBPACK FOOTER //
// ./src/helpers/leaflet-patch-browser-print.js